import React, {Component} from 'react'
import axios from 'axios'
import config from '../../config'
import {request} from '../../bpjs-api/authorized-request'

const route = config.route
const isnum = (val) => /^\d+$/.test(val)

class ProvinsiDropdown extends Component {
  state = {
    options: [],
    selected: ""
  }

  componentDidMount() {
    // axios.get(`${route}/bpjs-api/getprovinsi`)
    request('getprovinsi', 'get')
    .then(res => {
      const data = Array.isArray(res.data) ? res.data : [res.data]
      this.setState({
        options: data.map(
          val => ({
            text: val.nama,
            value: val.kode
          })
        )
      })
    })
  }

  render() {
    return (
      <div>
        <label className="custom-label"><b>Pilih provinsi tempat anda bekerja</b></label>
        <select onChange={(val) => {this.props.onDropdownChange('Provinsi', val.target.value, val); this.setState({selected: val.target.value});}} 
                name="Provinsi" 
                className="w3-select w3-margin-top w3-margin-bottom custom-field" name="option" 
                style={(this.props.errorProvinsi) ? {border: 'solid 1px #D0021B'} : {}}>
          <option value=""> -- Provinsi -- </option>
          { this.state.options.map((opt, i) => (<option key={i} value={opt.value}>{opt.text}</option>)) }
        </select>
      </div>
    )
  }
}

export default ProvinsiDropdown


// WEBPACK FOOTER //
// ./src/component/AddressDropdown/ProvinsiDropdown.js